import { useState, useEffect } from "react";

export const useScroll = (refOrId?: React.RefObject<HTMLElement> | string) => {
  const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    let target: HTMLElement | Window;

    if (typeof refOrId === "string") {
      // If refOrId is a string, use getElementById
      target = document.getElementById(refOrId) || window;
    } else {
      // If refOrId is a ref, use the ref's current property
      target = refOrId?.current || window;
    }

    const handleScroll = () => {
      if (target instanceof HTMLElement) {
        setScrollPosition({
          x: target.scrollLeft,
          y: target.scrollTop,
        });
      } else {
        setScrollPosition({
          x: window.scrollX,
          y: window.scrollY,
        });
      }
    };

    target.addEventListener("scroll", handleScroll);

    // Initial scroll position
    handleScroll();

    return () => {
      target.removeEventListener("scroll", handleScroll);
    };
  }, [refOrId]);

  return scrollPosition;
};
